import { FetchClient } from '@yellowtail-frontend/cord-connector';
import { from, Observable } from 'rxjs';
import { ApiCallMeBackRequest } from '../interfaces';

export class UniveWrapperApiService extends FetchClient {
  constructor(baseUrl: string) {
    super();
    this.baseUrl = baseUrl;
  }

  public post$<T>(resource: string, data: ApiCallMeBackRequest): Observable<T> {
    return from(this.post(resource, data));
  }
}
